import type { OwnApiTokenFormData } from '../components/_forms/own-api-token-form';
import type { CreatedApiToken } from './own-api-token.state';

/** The one call this helper needs from `BackendClient`, so it runs with a stand-in. */
export interface ApiTokenPoster {
    post<T>(uri: string, authRequired: boolean, requestBody: Record<string, unknown>): Promise<T | null>;
}

/** What creating a token did: created (with the token, shown once), or refused (a throw included). */
export type OwnApiTokenCreateOutcome =
    | { kind: 'created'; created: CreatedApiToken }
    | { kind: 'refused'; error: unknown };

/**
 * Creates a personal API token: posts name, validity and the current password as JSON to
 * POST /api/v1/me/api-tokens, which generates the token on the server and returns it once. Not a
 * command on purpose — the token must never come from the browser. The password is cleared from the
 * request body after every outcome.
 */
export async function createOwnApiToken(value: OwnApiTokenFormData, client: ApiTokenPoster): Promise<OwnApiTokenCreateOutcome> {
    const body: Record<string, unknown> = { name: value.name, expiresInDays: value.expiresInDays, currentPassword: value.currentPassword };
    try {
        const created = await client.post<CreatedApiToken>('/api/v1/me/api-tokens', true, body);

        return created ? { kind: 'created', created } : { kind: 'refused', error: new Error('empty answer') };
    } catch (error) {
        return { kind: 'refused', error };
    } finally {
        body.currentPassword = '';
    }
}
